export default function CmsInstructionAccordion(props: {
    // seoInstruction: string;
    cmsInstruction: string;
}) {
    return (
        <div className="space-x-4 ">
            <h2 className="inline-block text-center object-center">
                Instructions
            </h2>
            <div className="grid-cols-1 grid gap-4">
                <div className="inline-block object-left items-left">
                    {/* <input
                        type="checkbox"
                        name="panel"
                        id="panel-1"
                        className="hidden"
                    />
                    <label
                        htmlFor="panel-1"
                        className="plus relative block bg-slate-50 text-black p-4 shadow border border-white rounded"
                    >
                        Instruction SEO Employee
                    </label>

                    <div className="accordion__content overflow-hidden bg-grey-lighter">
                        <p className="accordion__body p-4" id="panel1">
                            {props.seoInstruction}
                        </p>
                    </div> */}
                </div>
                <div className="inline-block object-left items-left">
                    <input
                        type="checkbox"
                        name="panel"
                        id="panel-2"
                        className="hidden"
                    />
                    <label
                        htmlFor="panel-2"
                        className=" plus relative block bg-slate-50 text-black p-4 shadow border border-white rounded"
                    >
                        Instruction to Content Writer
                    </label>
                    <div className="accordion__content overflow-hidden bg-grey-lighter">
                        <p className="accordion__body p-4">
                            {props.cmsInstruction}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
